module.exports = __webpack_public_path__ + "static/img/partner-bscscan.7d732b97.png";